// extracted by mini-css-extract-plugin
export default {"header":"EditProfile_header__X7zEv","loading":"EditProfile_loading__RpA4Z"};